import { Section } from '../types/yellowHiveTypes';

const YINCO_LOGO = 'https://yinco.nl/application/files/6217/5274/1142/480.png';
const CTA_AANVRAGEN_PART = 'https://mijntp.nl/login';
const CTA_BEHEREN = 'https://adviseur.yinco.nl/';

export const particulierSections: Section[] = [
  {
    id: 'gezin',
    title: 'Jij & jouw gezin',
    iconType: 'Scale',
    products: [
      {
        id: 'aansprakelijkheidsverzekering',
        name: 'Aansprakelijkheidsverzekering',
        category: 'Particulier',
        section: 'gezin',
        description:
          'Vergoedt schade die jij (of je kind/huisdier) aan anderen of hun spullen veroorzaakt.',
        logo: YINCO_LOGO,
        tags: [],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'rechtsbijstandsverzekering',
        name: 'Rechtsbijstandsverzekering',
        category: 'Particulier',
        section: 'gezin',
        description:
          'Biedt juridische hulp en kostenvergoeding bij conflicten (o.a. consument, wonen, werk, verkeer).',
        logo: YINCO_LOGO,
        tags: [],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'ongevallenverzekering',
        name: 'Ongevallenverzekering',
        category: 'Particulier',
        section: 'gezin',
        description:
          'Keert een vast bedrag uit bij blijvende invaliditeit of overlijden door een ongeval.',
        logo: YINCO_LOGO,
        tags: [],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'wonen',
    title: 'Wonen',
    iconType: 'Building2',
    products: [
      {
        id: 'woonhuisverzekering-opstal',
        name: 'Woonhuisverzekering (opstal)',
        category: 'Particulier',
        section: 'wonen',
        description:
          'Dekt schade aan je huis door o.a. brand, storm en water; alles wat vastzit aan de woning.',
        logo: YINCO_LOGO,
        tags: ['vastgoed'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'inboedelverzekering',
        name: 'Inboedelverzekering',
        category: 'Particulier',
        section: 'wonen',
        description:
          'Dekt schade of diefstal van je huisraad; wat niet “vast” aan de woning zit.',
        logo: YINCO_LOGO,
        tags: ['vastgoed'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'verkeer',
    title: 'Onderweg',
    iconType: 'Car',
    products: [
      {
        id: 'autoverzekering',
        name: 'Autoverzekering',
        category: 'Particulier',
        section: 'verkeer',
        description:
          'Wettelijke Aansprakelijkheid (verplicht) met optie beperkt/volledig casco voor eigen autoschade.',
        logo: YINCO_LOGO,
        tags: ['transport'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'motorverzekering',
        name: 'Motorverzekering',
        category: 'Particulier',
        section: 'verkeer',
        description:
          'WA (verplicht) met casco-opties voor schade aan je motor; diefstal/schade mogelijk meeverzekerd.',
        logo: YINCO_LOGO,
        tags: ['transport'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'bromfietsverzekering',
        name: 'Bromfietsverzekering',
        category: 'Particulier',
        section: 'verkeer',
        description:
          'Voor brom/snorfiets (en brommobiel); WA verplicht, casco-dekkingen mogelijk.',
        logo: YINCO_LOGO,
        tags: ['transport'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'oldtimerverzekering',
        name: 'Oldtimerverzekering',
        category: 'Particulier',
        section: 'verkeer',
        description:
          'Voor klassiekers met beperkt gebruik; WA en cascodekking mogelijk.',
        logo: YINCO_LOGO,
        tags: ['transport'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'aanhangwagenverzekering-particulier',
        name: 'Aanhangwagenverzekering (particulier)',
        category: 'Particulier',
        section: 'verkeer',
        description:
          'Dekt schade aan de aanhangwagen; aansprakelijkheid loopt via het trekkende voertuig.',
        logo: YINCO_LOGO,
        tags: ['transport'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'vrijetijd',
    title: 'Reizen & vrije tijd',
    iconType: 'Palmtree',
    products: [
      {
        id: 'kampeerautoverzekering',
        name: 'Kampeerautoverzekering',
        category: 'Particulier',
        section: 'vrijetijd',
        description:
          'WA (verplicht) met casco-opties voor campers, incl. schade/diefstal.',
        logo: YINCO_LOGO,
        tags: ['reizen'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'caravanverzekering',
        name: 'Caravanverzekering',
        category: 'Particulier',
        section: 'vrijetijd',
        description:
          'Dekt schade aan toercaravan/vouwwagen; uitbreidbaar voor accessoires.',
        logo: YINCO_LOGO,
        tags: ['reizen'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'bootverzekering',
        name: 'Bootverzekering',
        category: 'Particulier',
        section: 'vrijetijd',
        description:
          'Dekt schade aan de boot en aansprakelijkheid voor schade aan anderen.',
        logo: YINCO_LOGO,
        tags: ['scheepvaart'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'doorlopende-reis-annuleringsverzekering',
        name: 'Doorlopende reis- en annuleringsverzekering',
        category: 'Particulier',
        section: 'vrijetijd',
        description:
          'Doorlopende dekking voor o.a. noodhulp, medische kosten, bagage; optie annulering.',
        logo: YINCO_LOGO,
        tags: ['reizen'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'recreatiewoningverzekering',
        name: 'Recreatiewoningverzekering',
        category: 'Particulier',
        section: 'vrijetijd',
        description:
          'Dekt opstal/inboedel van recreatiewoning en aansprakelijkheid rond het object.',
        logo: YINCO_LOGO,
        tags: ['vastgoed'],
        ctaRequestUrl: CTA_AANVRAGEN_PART,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
];
